import { render, staticRenderFns } from "./CollectionRequestTable.vue?vue&type=template&id=82e10fe0&scoped=true&"
import script from "./CollectionRequestTable.vue?vue&type=script&lang=js&"
export * from "./CollectionRequestTable.vue?vue&type=script&lang=js&"
import style0 from "./CollectionRequestTable.vue?vue&type=style&index=0&id=82e10fe0&lang=scss&scoped=true&"
import style1 from "./CollectionRequestTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82e10fe0",
  null
  
)

export default component.exports